import { render, staticRenderFns } from "./SchoolBanner.vue?vue&type=template&id=38b405ee&"
import script from "./SchoolBanner.vue?vue&type=script&lang=js&"
export * from "./SchoolBanner.vue?vue&type=script&lang=js&"
import style0 from "./SchoolBanner.vue?vue&type=style&index=0&id=38b405ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports